import type { Dispatch } from "react"
import { useReducer } from "react"

import type { DispatchAction } from "createProposal/types/dispatch"
import { DispatchActionMethod } from "createProposal/types/dispatch"
import type { CreateProposalFormState } from "createProposal/types/form"
import { StepName } from "createProposal/types/form"

type CreateProposalFormStateMachine = {
  state: CreateProposalFormState
  dispatch: Dispatch<DispatchAction>
}

const reducer = (
  state: CreateProposalFormState,
  dispatchAction: DispatchAction,
): CreateProposalFormState => {
  const { currentStep } = state
  const { method } = dispatchAction

  switch (method) {
    case DispatchActionMethod.NEXT_STEP:
      return {
        ...state,
        currentStep: currentStep + 1,
      }
    case DispatchActionMethod.PREVIOUS_STEP:
      return {
        ...state,
        currentStep: currentStep - 1,
      }
    case DispatchActionMethod.TO_STEP:
      const { to, shouldRunSimulation } = dispatchAction.payload

      return {
        ...state,
        currentStep: to,

        shouldRunSimulation:
          shouldRunSimulation !== undefined
            ? shouldRunSimulation
            : state.shouldRunSimulation,
      }
    case DispatchActionMethod.SET_GOVERNOR_PROPOSAL_STEPS:
      return {
        ...state,
        currentStep: StepName.CONNECT_WALLET,
        steps: [
          StepName.CONNECT_WALLET,
          StepName.DETAILS,
          StepName.ACTIONS,
          StepName.SUMMARY,
          StepName.IMPACT,
        ],
      }
    case DispatchActionMethod.RESET_SIMULATION:
      return {
        ...state,
        shouldRunSimulation: false,
      }
    default:
      return state
  }
}

type Props = {
  firstStep?: StepName
}
export const useCreateProposalForm = (
  props: Props = {},
): CreateProposalFormStateMachine => {
  const firstStep = props?.firstStep ?? StepName.CONNECT_WALLET

  const [state, dispatch] = useReducer(reducer, {
    currentStep: firstStep,
    steps: [
      StepName.CONNECT_WALLET,
      StepName.DETAILS,
      StepName.SUMMARY,
      StepName.IMPACT,
    ],
    shouldRunSimulation: false,
  })

  return {
    state,
    dispatch,
  }
}
